import { Wrench, Cctv, Droplets, Cable, Shovel, Waypoints } from "lucide-react";

export const PHONE = "01604 918385";
export const PHONE_HREF = "tel:+441604918385";
export const EMAIL = "info@pipe-lineuk.com";

export const NAV = [
  { id: "services", label: "Services" },
  { id: "about", label: "About" },
  { id: "process", label: "How it Works" },
  { id: "testimonials", label: "Reviews" },
  { id: "contact", label: "Contact" },
];

export const SERVICES = [
  { icon: Wrench, title: "Drainage Installations & Repairs", text: "New foul and surface water systems, soakaways and repairs to cracked, collapsed or displaced pipework, built to last." },
  { icon: Cctv, title: "CCTV Surveys & Investigations", text: "High-definition camera surveys that pinpoint blockages, root ingress and defects, with clear reports for homebuyers and insurers." },
  { icon: Droplets, title: "Drain Jetting & Clearance", text: "High-pressure water jetting that clears fat, silt, scale and debris fast, restoring full flow without digging." },
  { icon: Cable, title: "Utility Installation & Ducting", text: "Trenching and ducting for water, power, gas and data supplies, laid to spec and ready for connection." },
  { icon: Shovel, title: "Excavation & Reinstatement", text: "Careful excavation followed by tidy reinstatement of block paving, tarmac, concrete and lawns, leaving no trace." },
  { icon: Waypoints, title: "Trenchless Repairs", text: "Patch lining and no-dig relining that fixes damaged drains from the inside, saving your driveway and garden." },
];

export const TRUST = [
  { title: "Fully Insured", text: "Comprehensive public liability cover on every job." },
  { title: "Fast Response", text: "Rapid attendance when drains can't wait." },
  { title: "Domestic & Commercial", text: "From single homes to full site developments." },
  { title: "Tidy Reinstatement", text: "We leave every site as clean as we found it." },
];

export const STEPS = [
  { title: "Get in Touch", text: "Call us or send an enquiry. Tell us what's happening and we'll arrange a visit." },
  { title: "Survey & Quote", text: "We investigate the problem, often with CCTV, and give you a clear, fixed quote." },
  { title: "Job Done Right", text: "Our team completes the work to a high standard and reinstates the site cleanly." },
];

export const TESTIMONIALS = [
  { quote: "Collapsed drain under our driveway found by CCTV and relined the same week. No digging, no mess. Couldn't recommend them more.", name: "Sarah M.", role: "Homeowner" },
  { quote: "Pipe-Line UK handled the full drainage and utility ducting on our six-plot site. On time, on spec and great to work with.", name: "James T.", role: "Site Manager" },
  { quote: "Blocked drains at our restaurant on a Friday night. They jetted the line within hours and saved our weekend trade.", name: "Priya K.", role: "Business Owner" },
];
